const T_PREFIX = "favorites";

export const favoritesTrns = {
  title: `${T_PREFIX}.title`,
};

export const noFavoritesBannerTrns = {
  title: `${T_PREFIX}.no-favorites-banner.title`,
  description: `${T_PREFIX}.no-favorites-banner.description`,
  addClonesToFavoritesButton: `${T_PREFIX}.no-favorites-banner.add-clones-to-favorites-btn`,
};
